import {
  captureException,
  captureMessage,
  setContext,
  setTag,
  setExtra,
  showReportDialog as sentryShowReportDialog,
} from '@sentry/nuxt'

export default defineNuxtPlugin((nuxtApp) => {
  // @sentry/nuxt uses direct imports, not $sentry injection
  // Since @sentry/nuxt is configured with lazy: true, these imports
  // won't inflate the main bundle - they only load when used
  const sentryWrapper = {
    captureException: (error: any, context?: any) =>
      captureException(error, context),
    captureMessage: (message: string, level?: any) =>
      captureMessage(message, level),
    setContext: (key: string, context: any) => setContext(key, context),
    setTag: (key: string, value: any) => setTag(key, value),
    setExtra: (key: string, extra: any) => setExtra(key, extra),
    showReportDialog: (options?: any) => {
      if (process.client && sentryShowReportDialog) {
        try {
          return sentryShowReportDialog(options)
        } catch (error) {
          console.warn('Sentry showReportDialog error:', error)
        }
      }
    },
  }

  // Provide $sentry wrapper
  nuxtApp.provide('sentry', sentryWrapper)

  // Provide $sentryReady that returns a promise resolving to the wrapper
  nuxtApp.provide('sentryReady', async () => {
    // For @sentry/nuxt, Sentry is immediately available after import
    return sentryWrapper
  })
})

// Type declarations for compatibility wrapper
declare module 'nuxt/app' {
  interface NuxtApp {
    $sentry: {
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      showReportDialog: (options?: any) => void
    }
    $sentryReady: () => Promise<{
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }>
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $sentry: {
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }
    $sentryReady: () => Promise<{
      captureException: (error: any, context?: any) => any
      captureMessage: (message: string, level?: any) => any
      setContext: (key: string, context: any) => void
      setTag: (key: string, value: any) => void
      setExtra: (key: string, extra: any) => void
      getClient: () => any
      showReportDialog: (options?: any) => void
    }>
  }
}
